
import { Component, Prop } from "vue-property-decorator";
import Vue from "vue";
import { RouterQuery } from '@/router/Routes';
import { namespace } from 'vuex-class';

const RouterModule = namespace('Router');

@Component({
  name: 'AppContent'
})
export default class AppContent extends Vue {
  @Prop({ default: false })
  private noPadding: boolean;

  @Prop({ default: false })
  private mapLoading: boolean

  @Prop({ default: false })
  private removeTopBottomPadding: boolean;

  @Prop({ default: false })
  private forceNoMap: boolean;

  @RouterModule.State('query')
  private query: RouterQuery;

  private fullscreenRendered = false;

  get hasMap() {
    return !this.forceNoMap && !!this.$scopedSlots.map;
  }

  get hasFullscreenMap() {
    return !this.forceNoMap && !!this.$scopedSlots.fullscreenMap;
  }

  get fullscreenMap() {
    return this.query.fullscreenMap === 'true';
  }

  get fullscreenAlreadyRendered() {
    if (this.fullscreenMap && !this.fullscreenRendered) {
      this.fullscreenRendered = true;
    }
    return this.fullscreenRendered;
  }

  private mapClicked() {
    if (this.fullscreenMapSlot) {
      const query = {
        ...this.query,
        fullscreenMap: 'true'
      };

      this.$router.push({ query });
    }
  }

  get ariaBusy() {
    return this.mapLoading ? 'true' : 'false';
  }

  get fullscreenMapSlot() {
    return !!this.$scopedSlots.fullscreenMap;
  }
}
